import { cls } from "@/utils/util";
import { Link, useLocation } from "react-router-dom";
import HeaderFlag from "@/component/header/HeaderFlag";
import { ChicruitingLogo } from "../Logo";
import { useRecoilValue } from "recoil";
import { tokenState } from "state";
import { trackHeaderMenuClicked } from "@/tracking";

const BrandTabIcon = ({ value }: { value: "shurink" | "ray" }) => {
  const isShurink = value === "shurink";
  return (
    <span
      style={{
        display: "flex",
        flexShrink: 0,
        alignItems: "center",
      }}
    >
      <img
        src={isShurink ? "/img/shurink/shurink-icon.png" : "/img/ray/ico-ray-logo.png"}
        style={{
          display: "block",
          ...(isShurink ? { width: 22, height: 30 } : { width: 22, height: 22, marginRight: 2 }),
        }}
        alt=""
      />
    </span>
  );
};

const TabItem = ({
  isActive: isActiveProp,
  current,
  tab,
  color,
  scrolled,
  onHover,
  width,
  children,
}: {
  isActive?: boolean;
  current?: string;
  tab: { value: string; label: string; url: string; width: number; subTabs: any };
  color: string | null | undefined;
  scrolled: boolean;
  onHover: () => void;
  width: number;
  children?: React.ReactNode;
}) => {
  const token = useRecoilValue(tokenState);
  const location = useLocation();
  const isShurink = tab.value === "shurink";
  const isRay = tab.value === "ray";
  const isActive = current !== undefined ? current === tab.value : isActiveProp ?? false;
  const isBrandTab = isShurink || isRay;

  return (
    <>
      <div
        className="flex items-center justify-center whitespace-nowrap"
        style={isBrandTab ? { width } : { minWidth: width }}
        onMouseEnter={() => onHover()}
      >
        <Link
          className={cls(
            color ? `text-${color}` : "",
            isActive
              ? color
                ? "text-opacity-100 font-bold"
                : "text-medi-color-purple-600 font-medium"
              : color
              ? "text-opacity-50 font-medium hover:text-opacity-100 hover:font-bold"
              : "font-medium text-medi-text-primary hover:text-medi-color-purple-600",
            "text-[14px] py-4 flex items-center relative",
            isBrandTab &&
              "py-[6px] px-[10px] gap-[2px] rounded-[999px] bg-white hover:bg-medi-bg-primaryHover !text-medi-text-primary border border-medi-border-primary overflow-hidden w-full justify-center",
            ((isShurink && isActive) || (isRay && isActive)) &&
              "bg-white border-medi-color-purple-100 border-[1.5px] shadow-[0_0_0_2px_var(--medi-color-purple-100)]",
          )}
          style={
            isBrandTab
              ? {
                  height: 32,
                  minHeight: 32,
                  display: "flex",
                  alignItems: "center",
                  overflow: "hidden",
                  boxSizing: "border-box",
                }
              : undefined
          }
          to={tab.url}
          onClick={() =>
            trackHeaderMenuClicked({
              page_name: location.pathname,
              section_name: `메뉴 > ${tab.label}`,
              button_name: tab.label,
              user_id: token?.sub,
              customer_id: token?.customerId,
            })
          }
        >
          {!scrolled && <HeaderFlag value={tab.value} />}
          {isShurink && <BrandTabIcon value="shurink" />}
          {isRay && <BrandTabIcon value="ray" />}
          {tab.value === "chicruiting" ? <ChicruitingLogo width={74} color={color} /> : tab.label}
        </Link>
      </div>
      {children}
    </>
  );
};

export default TabItem;
